import React, { HTMLAttributes } from 'react';
import * as iconStyles from '../../styles/icons/virtualIcon.module.scss';
import * as styles from '../../styles/nvIcons.module.scss';

const VirtualIcon: React.FC<HTMLAttributes<HTMLElement>> = (props) => (
  <i
    {...props}
    className={`${props.className} ${styles.nv_icon_call_forward} ${iconStyles.icon}`}
  ></i>
);

export default VirtualIcon;
